<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

definePage({ meta: { title: 'Integrity Check' } });

const router = useRouter();
onMounted(() => {
  void router.replace('/reports/data-quality');
});
</script>

<template>
  <div class="flex items-center justify-center h-full text-sm text-text-muted">Redirecting to Data Quality Report…</div>
</template>
